<template>
  <div class="categories">
    <v-card-text >
      <v-row>
<!--        <v-col cols="3" v-for="item in items" :key="item.Id">-->
<!--          <div  >-->
<!--            <div  v-on:click="goToDetail(item.Id,item.CategoryGroupTitle)">-->
<!--              <div class="row" style="text-align: center">-->
<!--                <div class="col-12">-->
<!--                  <img style="width: 80%;height: auto;padding: 0px;border-radius: 10px;" :src="item.ImageUrl" />-->
<!--                </div>-->
<!--                <div class="col-12" style="text-align: center">-->
<!--            <span class="name" style="font-size: 12px;text-align: center;line-height: 1.1rem;color: black">-->
<!--              {{item.CategoryGroupTitle}}-->
<!--            </span>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->

<!--          </div>-->
<!--        </v-col>-->
        <v-col cols="6 col-sm-4 col-md-3 col-lg-2" v-for="item in items" :key="item.Id">
          <div >
            <MainBox :title="item.Name" @click.native="goToDetail(item.Id,item.ParentId)"
                     :class="last_class_name+' group-box invert-white'" :image="item.Image"/>

          </div>
        </v-col>
      </v-row>

    </v-card-text>

  </div>

</template>
<script>
  import zood_data from "./categories";
  import MainBox from "../../components/MainBox";
  export default {
    components:{
      MainBox
    },
    data () {
      return {
        last_class_name : '',
        items:[],
        selected_item_id:'',
        errors: [],
        rules: {
          required: value => !!value || this.$t('necessary'),
          fullName: value => value.length <= 30 || this.$t('max30Character'),
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || this.$t('nameNotFarsi')
          },
          mobile: value => {
            const pattern = /^[a-zA-Z0-9._ \-]*$/
            return pattern.test(value) || this.$t('modelNotCorrect')
          },
        },
      }
    },
watch: {

    },
mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
  console.log('subgroups passing_data',passing_data)
     this.selected_item_id = passing_data.sub_group_id
  this.last_class_name = passing_data.class_id

      this.get_categories()
    },
    methods: {
      get_item_color (item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      goToDetail (item_id, cat_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.sub_group_id = item_id
        passing_data.original_cat_id = cat_id
        passing_data.request_name =  ' '

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        // this.$router.push({ path: 'brands', params: {} })
        this.$router.push({ name: 'posts', params: {} })
      },
      get_categories () {
        // console.log("datas is "+localStorage.getItem('request_data'))

        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var group_id = passing_data.group_id
        const send_data = {
          catId: group_id,
        }
        console.log('subcats is ',zood_data.cats[group_id])
              self.items = zood_data.cats[group_id]

        //
        // // this.axios.post('/Register' , send_data,{
        // this.axios.post('/GetReqCategoryGroupListRelByCatId', send_data, {})
        //   .then(response => {
        //     if (response.data.error == 0) {
        //       // console.log("response", response);
        //       // self.fullName = response.data.msg;
        //       self.items = response.data.groups
        //       // self.level = 2;
        //     }
        //     // this.$router.push({ path: "/post-login", params: {} });
        //   }).catch(e => {
        //   this.errors.push(e)
        // })
      }
    }
  }
</script>
